<template>
    <div class="top-navigation">
        <div class="top-wrap">
            <div class="top-left">
                <img class="img-width-100"  src="../../public/img/xinzhu-logo.png"  @click="returnHome()">
            </div>
            <div class="top-right">
                <div v-for="(item, index ) in topTitleList" :key="item" class="menu-one"><span :class="index == chooseTitleIndex ?  'menu-one-active': ''"  @click="chooseOneTitle(index)">{{item.name}}</span></div>
                <!--<div class="menu-one">产品及服务</div>
                <div class="menu-one">营销解决方案</div>
                <div class="menu-one">关于我们</div>
                <div class="menu-one">加入新竹</div>-->
            </div>
        </div>
    </div>
</template>

<script>
/*import Swiper from 'swiper'
import 'swiper/css/swiper.css'*/
export default {
    name: "TopNavigation",
    /*components: {
        Swiper
    },*/
    data() {
        return {
            account: undefined,
            password: undefined,
            swiper: undefined,
            chooseTitleIndex: 0,
            topTitleList: [
                {
                    name: '营销解决方案',
                    path: '/',
                },
                {
                    name: '产品及服务',
                    path: '/ChanPinFuWu',
                },
                /*{
                    name: '营销解决方案',
                    path: '',
                },*/
                {
                    name: '关于我们',
                    path: '/AboutCompany',
                },
                {
                    name: '我们的权益',
                    path: '/QuanYi',
                },
                {
                    name: '加入我们',
                    path: '/JoinCompany',
                },
            ]
        }
    },
    props:{
        choosseIndex: { type: Number, default: 0 },
    },
    watch: {
        //监听路由地址的改变
        $route:{
            immediate:true,
            handler(){
                // console.log(this.$route.path)
                let pathUrl = this.$route.path
                // console.log(pathUrl)
                for (let i = 0; i < this.topTitleList.length; i++) {
                    if (pathUrl == this.topTitleList[i].path) {
                        this.chooseTitleIndex = i
                    }
                }
                // 监听url改变判断导航栏跳到哪一项
               /* if(this.$route.query.titleIndex){//需要监听的参数
                    this.chooseTitleIndex = this.$route.query.titleIndex
                }*/
            }
        }
    },
    created() {
        console.log(this.choosseIndex)

    },
    mounted() {
        console.log(window.location.href)
    },
    methods: {
        chooseOneTitle(index) {
            this.chooseTitleIndex = index
            if (index == 0) {
                this.$router.push('/')
            } else {
                let path = this.topTitleList[index].path
                this.$router.push(path)
            }
        },
        // 返回首页
        returnHome() {
            this.$router.replace('/')
        }
    }
}
</script>

<style scoped lang="scss">
   .img-width-100{
       width: 100%;
   }
    .top-wrap{
        padding: 22px 77px 3px 9vw;
        display: flex;
        justify-content: space-between;
        .top-left{
            width:11vw;
        }
        .top-right{
            display: flex;
            align-items: center;
            color: #393939;
            font-size: 16px;
            .menu-one{
                /*border: 1px solid red;*/
                width: 10vw;
                font-size: 18px;
                color: #161616;
                text-align: center;
                padding: 4px 0px;
                letter-spacing: 2px;
            }
            .menu-one-active{
                color: #006fff;
                border-bottom: 4px solid #006fff;
                padding-bottom: 9px;
            }
        }
    }
   a {
       text-decoration: none; /*去除下划线*/
       color: inherit; /*继承父元素颜色*/
   }
</style>
